import { Injectable, Injector } from "@angular/core";
import { Observable } from "rxjs/Observable";
import 'rxjs/Rx';
import 'rxjs/add/operator/catch';


import * as _ from 'lodash';
import { EndpointFactory } from "./endpoint-factory.service";
import { HttpClient } from "@angular/common/http";
import { ConfigurationService } from "./configuration.service";
import { extend } from "jquery";

@Injectable()
export class ReasonService extends EndpointFactory {

    private _baseURl = '';

    constructor(http: HttpClient, configurations: ConfigurationService, injector: Injector) {
        super(http, configurations, injector);
    }

    getAllMemberAccessReason(): Observable<any> {
        return this.http
            .get(this._baseURl + 'api/memberAccessReason/get-all-member-access-reasons', this.getRequestHeaders())
            .catch(err => {
                return this.handleError(err, null);
            })
    }

    createMemberAccessReason(memberAccessReason): Observable<any> {
        return this.http
            .post(this._baseURl + `api/memberAccessReason/create`, memberAccessReason, this.getRequestHeaders())
            .catch(err => {
                return this.handleError(err, null);
            })
    }


    updateMemberAccessReason(memberAccessReason): Observable<any> {
        return this.http
            .put(this._baseURl + `api/memberAccessReason/update`, memberAccessReason, this.getRequestHeaders())
            .catch(err => {
                return this.handleError(err, null);
            })
    }


    deleteMemberAccessReason(memberAccessReasonId): Observable<any> {
        return this.http 
            .delete(this._baseURl + `api/memberAccessReason/delete/${memberAccessReasonId}`, this.getRequestHeaders())
            .catch(err => {
                return this.handleError(err, null);
            })
    }
    
    

}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./ClientApp/app/services/reason.service.ts